module.exports = __webpack_public_path__ + "static/media/clinician-watchman-preview@3x.7c61fafa.jpg";